import {
  faSun,
  faClock,
  faSchool,
  faBaby,
  faCalendarWeek,
  faGraduationCap,
  faEuroSign,
  faBriefcase,
  faHeart,
  faUsers,
  faSeedling,
  faShieldAlt,
  faAppleAlt,
  faCalendarCheck,
  faMapMarkedAlt,
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
  faHome,
  faBookOpen,
  faStar,
  faImages,
  faChevronDown,
  faChevronRight,
  faGift,
  faBars,
  faTimes,
  faPalette,
  faMusic,
  faUtensils,
  faChild,
  faGamepad,
  faRunning,
  faArrowRight,
  faWalking,
  faSearch,
  faShoppingCart,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import {faFacebookF, faInstagram, faTwitter, faLinkedinIn, faYoutube, faCss3} from "@fortawesome/free-brands-svg-icons";

const IconMap = {
  faSun,
  faClock,
  faSchool,
  faBaby,
  faCalendarWeek,
  faGraduationCap,
  faEuroSign,
  faHeart,
  faBriefcase,
  faUsers,
  faSeedling,
  faShieldAlt,
  faAppleAlt,
  faCalendarCheck,
  faMapMarkedAlt,
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faTwitter,
  faYoutube,
  faCss3,
  faHome,
  faBookOpen,
  faStar,
  faImages,
  faChevronDown,
  faChevronRight,
  faGift,
  faBars,
  faTimes,
  faPalette,
  faMusic,
  faUtensils,
  faChild,
  faGamepad,
  faRunning,
  faArrowRight,
  faWalking,
  faSearch,
  faShoppingCart,
  faUser,
};

export default IconMap;
